import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Button from 'carbon-react/lib/components/button';

import { getForecastOnboardingUrl } from '@futrli/shared-services';
import { UISystemIcon } from '@futrli/ui-components';

import { BudgetOnboardingNav } from './budget/budget-onboarding-nav';
import * as styles from './forecasting-onboarding.scss';
import { BUDGET_ONBOARDING_STEP, LS_FORECASTING_ONBOARDING_STEP } from './const';
import { OnboardingPageTitle } from './components/onboarding-page-title';

export const BUDGET_ONBOARDING_STEPS = 7;

export const ForecastingOnboardingStart = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const [selectedForecastType, setSelectedForecastType] = useState<number | null>(null);

  const navigate = useNavigate();

  const handleNextClick = () => {
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, BUDGET_ONBOARDING_STEP.START_MONTH);
    navigate(
      `${getForecastOnboardingUrl(workspaceId, organisationId, selectedForecastType === 0)}/${
        BUDGET_ONBOARDING_STEP.START_MONTH
      }`
    );
  };

  return (
    <div>
      <BudgetOnboardingNav />
      <div className={styles.contentContainer}>
        <OnboardingPageTitle
          title={
            <FormattedMessage
              id="onboarding.what_type_of_forecast"
              defaultMessage="What type of budget or forecast do you want?"
            />
          }
          description={
            <FormattedMessage
              id="onboarding.different_option_later"
              defaultMessage="You can create the different option later."
            />
          }
        />
        <div style={{ display: 'flex', marginBottom: 20 }}>
          <div
            className={classNames(styles.onboardingStartButton, {
              [styles.onboardingStartButtonActive]: selectedForecastType === 0
            })}
            onClick={() => setSelectedForecastType(0)}
          >
            {selectedForecastType === 0 ? (
              <UISystemIcon iconName="double-check-onboarding" width={40} height={40} />
            ) : (
              <UISystemIcon iconName="onboarding-budget" width={40} height={40} />
            )}
            <FormattedMessage id="predict.one_year_p_l_only" defaultMessage="1 year P&L only" />
          </div>
          <div
            className={classNames(styles.onboardingStartButton, {
              [styles.onboardingStartButtonActive]: selectedForecastType === 1
            })}
            style={{ marginLeft: 40 }}
            onClick={() => setSelectedForecastType(1)}
          >
            {selectedForecastType === 1 ? (
              <UISystemIcon iconName="double-check-onboarding" width={40} height={40} />
            ) : (
              <UISystemIcon iconName="create-forecast-start" width={40} height={40} />
            )}
            <FormattedMessage id="onboarding.3_year_cash_flow_forecast" defaultMessage="3 year cash flow forecast" />
          </div>
        </div>
        <Button disabled={selectedForecastType === null} onClick={handleNextClick} buttonType="primary" size="large">
          <FormattedMessage id="common.next" defaultMessage="Next" />
        </Button>
      </div>
    </div>
  );
};
